import React, { Component } from 'react'
import { connect } from 'react-redux'
import { formatName } from '../../../../helpers'

class OpenVoteAnswer extends Component {
  addMoreStyles (avatar) {
    if (avatar) {
      return {
        background: `url('${avatar}')`,
        backgroundSize: '25px 25px'
      }
    }
    return {}
  }

  render () {
    const { vote, players } = this.props
    const player = players.find(p => p.id === vote.participant) || {}

    return (
      <div className='vote-text-container'>
        <div className='user-left-wrap avatar-name-container'>
          <div className='user-image' style={this.addMoreStyles(player.avatar)} />
          <div className='name-text'>{formatName(player.name)}</div>
        </div>
        <div className='vote-text'>{vote.vote}</div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    players: state.participants
  }
}

export default connect(mapStateToProps)(OpenVoteAnswer)



// WEBPACK FOOTER //
// ./src/screens/dashboard/chat/results/OpenVoteAnswer.js